import { Api } from './BaseApi'

const WorkflowApi = Api.injectEndpoints({
    endpoints: (build) => ({
        applyWorkflow: build.mutation<number, { id: number, ticketId: number }>({
            query: (props) => ({
                url: `Workflow/${props.id}/Apply/${props.ticketId}`,
                method: "POST"
            }),
            invalidatesTags: ["GetActions", "GetTicket", "GetTicketDetails"]
        }),
        completeAction: build.mutation<number, { id: number }>({
            query: (props) => ({
                url: `Workflow/Action/${props.id}/Complete`,
                method: "POST"
            }),
            invalidatesTags: ["GetActions"]
        }),
    }),

    overrideExisting: false,
})

export { WorkflowApi };